export default "__VITE_ASSET__BgKrPVLA__"